"use client";

import { Card, CardContent, Typography, Box ,Button} from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip
} from "recharts";
import { ArrowRight } from "lucide-react";
import { NavLink } from "react-router-dom";

function CustomTooltip({ active, payload }: any) {
  if (active && payload?.length) {
    return (
      <Box
        sx={{
          backgroundColor: "white",
          border: "1px solid #ccc",
          px: 1.5,
          py: 1,
          borderRadius: 1,
          fontSize: "12px",
        }}
      >
        {payload.map((entry: any, index: number) => (
          <Typography key={index} sx={{ color: entry.color }}>
            {entry.name}: {entry.value}
          </Typography>
        ))}
      </Box>
    );
  }
  return null;
}

export function OffersSummaryWidget() {
  const data = [
    { name: "Received", offers: 12, rfqs: 8 },
    { name: "Posted", offers: 7, rfqs: 5 },
  ];

  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography
          variant="h6"
          sx={{ color: "#0d2561", fontWeight: 600, fontSize: "18px", mb: 1 }}
        >
          Offers on Properties / RFPs
        </Typography>

        <Typography
          variant="body2"
          sx={{ fontSize: "14px", color: "text.secondary", mb: 3 }}
        >
          Total offers received:{" "}
          <Box component="span" sx={{ fontWeight: 600, color: "#0A66C2" }}>
            12
          </Box>
          , Total offers posted:{" "}
          <Box component="span" sx={{ fontWeight: 600, color: "#0A66C2" }}>
            7
          </Box>
        </Typography>

        <Box sx={{ height: 200, width: "100%" }}>
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 10, right: 0, left: 0, bottom: 0 }}>
              <CartesianGrid vertical={false} strokeDasharray="3 3" />
              <XAxis
                dataKey="name"
                axisLine={false}
                tickLine={false}
                tickMargin={8}
                style={{ fontSize: 12 }}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                tickMargin={8}
                style={{ fontSize: 12 }}
              />
              <Tooltip content={<CustomTooltip />} />
              <Bar
                dataKey="offers"
                fill="#E76E50" // Updated Orange
                radius={[4, 4, 0, 0]}
                name="Offers"
              />
              <Bar
                dataKey="rfqs"
                fill="#2A9D90" // Updated Green
                radius={[4, 4, 0, 0]}
                name="RFPs"
              />
            </BarChart>
          </ResponsiveContainer>
        </Box>
        <Box textAlign="right">
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              sx={{ color: "#0d2561", textTransform: "none", fontSize: "0.875rem" }}
              endIcon={<ArrowRight size={16} />}
            >
              View all Offers
            </Button>
          </NavLink>
        </Box>

      </CardContent>
    </Card>
  );
}
